<template>
	<c-loader v-if="!blogLoaded" />
	<div v-else>
		<c-blog-posts-list :posts='itemList' />
		<div class="container">
			<div class="c-paginate">
				<!-- <button type='button'	 class='c-paginate-last' @click='last'> {{ 1 }} </button> -->
				<router-link class="c-paginate__button" v-if='currentPage !== 1' :to="{ query: { page: lastPage }}">←</router-link>
				<div class='c-paginate-current'>{{currentPage}} / {{totalPages}} </div>
				<router-link class="c-paginate__button" v-if='currentPage !== totalPages' :to="{ query: { page: nextPage }}">→</router-link>
				<!-- <button type='button'	 class='c-paginate-next' @click='next'> {{currentPage + 1}} </button> -->
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import CLoader from '@/components/Loader'
import CBlogPostsList from '@/components/BlogPostsList'

export default {
	name: 'paginate',
	components: {
		CBlogPostsList,
		CLoader
	},
	props: {
		itemList: {
			type: Array,
			default: () => []
		},
		currentPage: {
			type: Number,
			default: 1
		},
		totalItems: {
			type: Number,
			default: 0
		},
		pageSize: {
			type: Number,
			default: 20
		},
		loading: {
			type: Boolean,
			default: false
		},
		requestNext: {
			type: Function,
			default(pageNumber){}
		},
		requestLast: {
			type: Function,
			default(pageNumber){}
		}
	},
	computed: {
		offset () {
			return this.currentPage * this.pageSize
		},
		totalPages () {
			return Math.ceil(this.totalItems / this.pageSize)
		},
		lastPage () {
			return Math.max(this.currentPage - 1, 1)
		},
		nextPage () {
			return Math.min(this.currentPage + 1, this.totalPages)
		},
		...mapGetters(['blogLoaded'])
	},
	methods: {
		next () {
			this.requestNext(this.nextPage)
		},
		last () {
			this.requestLast(this.lastPage)
		}
	}
};
</script>

<style lang="scss">

@import '../assets/css/helpers';

.c-paginate {
	display: flex;
	justify-content: center;
	padding: 2rem 0;

	&__button {
		display: block;
		font-size: 1.5rem;
		line-height: 1rem;
		text-decoration: none;
		padding: 0 1rem;
		color: $colorGray;
	}
	&-current {
		padding: 0 .5rem;
		line-height: 1.3rem;
	}
}

</style>



// WEBPACK FOOTER //
// Paginate.vue?08e4d99a